import script from "./EditMenuView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMenuView.vue?vue&type=script&setup=true&lang=js"

import "./EditMenuView.vue?vue&type=style&index=0&id=4366eadb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4366eadb"]])

export default __exports__